import { pipe } from "fp-ts/function";
import {
  TextChildren,
  LocalizedString,
  ReadOnlyField,
} from "@dbn/omnichannel-design-system-g4p";
import { boolean } from "fp-ts";
import { useFormatMessage } from "../../intl";
import { ComponentProps } from "react";
import { ReadOnlyFieldToValue } from "../ReadOnlyField/ReadOnlyFieldToValue";

type Props = {
  id?: string;
  size: ComponentProps<typeof ReadOnlyField>["size"];
  value: boolean;
  label: TextChildren;
  description?: LocalizedString;
  descriptionAriaLabel?: LocalizedString;
  tooltipCloseIconAriaLabel?: LocalizedString;
};

export function ReadOnlyYesNoField(props: Props) {
  const formatMessage = useFormatMessage();
  return (
    <ReadOnlyFieldToValue
      {...props}
      value={pipe(
        props.value,
        boolean.fold(
          () => formatMessage("No"),
          () => formatMessage("Yes")
        )
      )}
    />
  );
}
